import { FACT_NAMES_BOOLEAN, FACT_NAMES_NUMERIC, FACT_NAMES_STRING } from '@trnsact/business-criteria';
import { z } from 'zod';
import { criteriaConditionSchema } from './model';
import { Nullable } from 'global';
import { FieldValues, Control, Path } from 'react-hook-form';

export enum ConditionsFieldsTypes {
  Boolean = 'boolean',
  Number = 'number',
  String = 'string',
}

export type AllRules = FACT_NAMES_BOOLEAN | FACT_NAMES_NUMERIC | FACT_NAMES_STRING;

export type CriteriaValue = z.infer<typeof criteriaConditionSchema>;

export interface CriteriaBodyCellProps<FormValues extends FieldValues = FieldValues> {
  name: Path<FormValues>;
  control: Control<FormValues>;
  ruleType: Nullable<string> | undefined;
}
